import { Trans } from '@lingui/macro'
import { IconButton, Menu, MenuItem, Typography } from '@material-ui/core'
import { AccountCircle } from '@material-ui/icons'
import { observer } from 'mobx-react-lite'
import React, { useRef, useState } from 'react'
import styled from 'react-emotion/macro'

import { LinkButton } from './LinkButton'
import { useRoot } from './RootProvider'

const DisplayName = styled(Typography)`
  margin-right: 0.5rem !important;
`

const AlignRight = styled.div`
  text-align: right;
`

export const UserBanner = observer(() => {
  const { auth, user } = useRoot()
  if (!auth.isAuthenticated) {
    return null
  }

  const [isMenuOpen, setMenuOpen] = useState(false)
  const buttonRef = useRef<HTMLElement | null>(null)

  return (
    <AlignRight>
      <IconButton
        aria-owns={isMenuOpen ? 'usermenu' : undefined}
        aria-haspopup="true"
        onClick={() => setMenuOpen(true)}
        color="inherit"
        buttonRef={buttonRef}
      >
        <DisplayName color="inherit">{user.displayName}</DisplayName>
        <AccountCircle />
      </IconButton>
      <Menu
        id="usermenu"
        anchorEl={buttonRef.current}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={isMenuOpen}
        onClose={() => setMenuOpen(false)}
        // onBackdropClick={() => setMenuOpen(true)}
      >
        <MenuItem>
          <LinkButton to="/register">
            <Trans>Přidat obchod</Trans>
          </LinkButton>
        </MenuItem>
        <MenuItem>
          <LinkButton to="/logout">
            <Trans>Odhlásit</Trans>
          </LinkButton>
        </MenuItem>
      </Menu>
    </AlignRight>
  )
})
